import {withStyles} from '@material-ui/core/styles'
import Checkbox from '@material-ui/core/Checkbox'

export default withStyles(() => ({
  root: {
    margin: '2px 6px 2px 12px',
    padding: 0,
  },
}))(Checkbox)
